export interface IAttachedFileList {
  readonly selectedObject: unknown;
  readonly type?: ITab;
  readonly source?: string;
  readonly embedded?: boolean;
}

export enum ITab {
  View = 'VIEW',
  FileFromConnect = 'FILE_FROM_CONNECT',
  FileFromComputer = 'FILE_FROM_COMPUTER',
  Link = 'LINK',
  All = 'ALL',
  ThreeDView = '3D_VIEW',
  TwoDView = '2D_VIEW',
}

export interface IAttachUrlFormData {
  readonly displayText: string;
  readonly webUrl: string;
}

export interface IVisibleTab {
  readonly type: ITab;
  readonly tabIcon: string;
}

export interface IAttachmentPickerProps {
  addAttachment(filesList: IAttachedFileList): void;
  readonly allowedAttachmentTypes: string;
  onClose(): void;
  readonly inProgressFlag?: boolean;
  readonly disableMultiSelect?: boolean;
  readonly allowedFileExtensions?: string[];
  readonly allowedUploadFileExt?: string[];
  readonly is3DEmbbedded?: boolean;
  readonly customTitle?: string;
  readonly customButtonName?: string;
  readonly allowedFileNames?: string[];
  readonly projectName?: string;
  // Required for API integration when using FILE_FROM_CONNECT
  readonly projectId?: string;
  readonly accessToken?: string;
  readonly tcpsApiDomain?: string;
}

export interface IFilesFromComputerProps {
  onFilesSubmit(filesList: IAttachedFileList): void;
  readonly tab: ITab;
  readonly isShowFileFromComputer: boolean;
  readonly disableMultiSelect?: boolean;
  readonly allowedUploadFileExt?: string[];
  readonly allowedFileExtensions?: string[];
  readonly allowedFileNames?: string[];
  readonly is3DEmbbedded?: boolean;
}

export interface IFilesFromConnectProps {
  onFilesSubmit(filesList: IAttachedFileList): void;
  readonly tab: ITab;
  readonly isShowFileFromConnect: boolean;
  readonly disableMultiSelect?: boolean;
  readonly allowedFileExtensions?: string[];
  readonly allowedFileNames?: string[];
  readonly is3DEmbbedded?: boolean;
  readonly projectName: string;
  readonly projectId?: string;
  readonly accessToken?: string;
  readonly tcpsApiDomain?: string;
}

export interface IAttachAsUrlProps {
  onFilesSubmit(filesList: IAttachedFileList): void;
  addAttachment(filesList: IAttachedFileList): void;
  readonly tab: ITab;
  readonly isShowLink: boolean;
  addRef?(el: HTMLButtonElement): void;
}

export interface IViewListProps {
  onFilesSubmit(filesList: IAttachedFileList): void;
  readonly tab: ITab;
  readonly isShowView: boolean;
  readonly isShow2DView: boolean;
  readonly isShow3DView: boolean;
  readonly disableMultiSelect?: boolean;
}
